export default __webpack_public_path__ + "static/media/tag_cancel.7e4cc651.svg";